"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "loading loading-2x"
};
const _hoisted_2 = {
    key: 0,
    class: "upgrade-message-overlay"
};
const _hoisted_3 = { class: "settings-card-container accordion settings-accordion" };
const _hoisted_4 = { class: "settings-title-wrapper c-hand" };
const _hoisted_5 = { class: "page-title-text" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "accordion-body" };
const _hoisted_8 = { class: "settings-item" };
const _hoisted_9 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_10 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_11 = { class: "settings-input oplus-form-switch" };
const _hoisted_12 = { class: "settings-item" };
const _hoisted_13 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_14 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_15 = { class: "settings-input oplus-form-switch" };
const _hoisted_16 = { class: "settings-item" };
const _hoisted_17 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_18 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_19 = { class: "settings-input oplus-form-switch" };
const _hoisted_20 = { class: "settings-item" };
const _hoisted_21 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_22 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_23 = { class: "settings-input oplus-form-switch" };
const _hoisted_24 = { class: "settings-item" };
const _hoisted_25 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_26 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_27 = { class: "d-flex flex-gap flex-wrap settings-input" };
const _hoisted_28 = { class: "form-label d-flex flex-center" };
const _hoisted_29 = ["value"];
const _hoisted_30 = { class: "settings-item" };
const _hoisted_31 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_32 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_33 = { class: "d-flex flex-gap flex-wrap settings-input" };
const _hoisted_34 = { class: "form-label d-flex flex-center" };
const _hoisted_35 = ["value"];
const _hoisted_36 = { class: "settings-item" };
const _hoisted_37 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_38 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_39 = { class: "d-flex flex-gap flex-wrap settings-input" };
const _hoisted_40 = { class: "form-label d-flex flex-center" };
const _hoisted_41 = ["value"];
const _hoisted_42 = { class: "settings-item" };
const _hoisted_43 = { class: "d-flex flex-gap flex-wrap flex-center justify-content-end settings-input" };
const _hoisted_44 = { class: "form-label d-flex flex-center" };
const _hoisted_45 = ["value"];
const _hoisted_46 = { class: "oplus-form-radio" };
const _hoisted_47 = { class: "oplus-form-radio" };
const _hoisted_48 = { class: "settings-item" };
const _hoisted_49 = { class: "d-flex flex-gap flex-wrap flex-center justify-content-end settings-input" };
const _hoisted_50 = { class: "form-label d-flex flex-center" };
const _hoisted_51 = ["value"];
const _hoisted_52 = { class: "oplus-form-radio" };
const _hoisted_53 = { class: "oplus-form-radio" };
const _hoisted_54 = { class: "settings-item" };
const _hoisted_55 = { class: "d-flex flex-gap flex-wrap flex-center justify-content-end settings-input" };
const _hoisted_56 = { class: "form-label d-flex flex-center" };
const _hoisted_57 = ["value"];
const _hoisted_58 = { class: "oplus-form-radio" };
const _hoisted_59 = { class: "oplus-form-radio" };
const _hoisted_60 = { class: "settings-item" };
const _hoisted_61 = { class: "d-flex flex-gap flex-wrap flex-center justify-content-end settings-input" };
const _hoisted_62 = { class: "form-label d-flex flex-center" };
const _hoisted_63 = ["value"];
const _hoisted_64 = { class: "oplus-form-radio" };
const _hoisted_65 = { class: "oplus-form-radio" };
const _hoisted_66 = { class: "settings-item" };
const _hoisted_67 = { class: "d-flex flex-gap flex-wrap justify-content-end auto-settings-wrapper settings-input" };
const _hoisted_68 = { class: "d-flex flex-gap flex-wrap flex-center justify-content-end auto-rest-container" };
const _hoisted_69 = { class: "oplus-form auto-rest-wrapper" };
const _hoisted_70 = ["value", "onChange"];
const _hoisted_71 = { class: "oplus-form auto-rest-wrapper" };
const _hoisted_72 = ["value", "onChange"];
const _hoisted_73 = ["onClick"];
const _hoisted_74 = { class: "settings-card-container accordion settings-accordion" };
const _hoisted_75 = { class: "settings-title-wrapper accordion-header c-hand" };
const _hoisted_76 = { class: "accordion-body" };
const _hoisted_77 = { class: "settings-item" };
const _hoisted_78 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_79 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_80 = { class: "settings-input oplus-form-switch" };
const _hoisted_81 = { class: "settings-card-container accordion settings-accordion" };
const _hoisted_82 = { class: "settings-title-wrapper accordion-header c-hand" };
const _hoisted_83 = { class: "accordion-body" };
const _hoisted_84 = { class: "settings-item" };
const _hoisted_85 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_86 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_87 = { class: "settings-input" };
const _hoisted_88 = { class: "d-flex justify-content-end" };
const _hoisted_89 = { class: "oplus-form-switch" };
const _hoisted_90 = {
    key: 0,
    class: "d-flex flex-wrap justify-content-end mt-1"
};
const _hoisted_91 = ["value"];
const _hoisted_92 = { class: "settings-item" };
const _hoisted_93 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_94 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_95 = { class: "settings-input oplus-form-switch" };
const _hoisted_96 = { class: "settings-item" };
const _hoisted_97 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_98 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_99 = { class: "settings-input oplus-form-switch" };
const _hoisted_100 = { class: "settings-card-container accordion settings-accordion" };
const _hoisted_101 = { class: "accordion-body" };
const _hoisted_102 = { class: "settings-item" };
const _hoisted_103 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_104 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_105 = { class: "oplus-form settings-input" };
const _hoisted_106 = ["value"];
const _hoisted_107 = { class: "settings-item" };
const _hoisted_108 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_109 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_110 = { class: "oplus-form settings-input" };
const _hoisted_111 = ["value"];
const _hoisted_112 = {
    key: 1,
    class: "settings-submit-button-wrapper"
};
const TimecardIcon_vue_1 = __importDefault(require("../icons/TimecardIcon.vue"));
const QRCodeIcon_vue_1 = __importDefault(require("../icons/QRCodeIcon.vue"));
const TimeIcon_vue_1 = __importDefault(require("../icons/TimeIcon.vue"));
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
const vue_3 = require("vue");
const dateInt_1 = __importDefault(require("../../common/dateInt"));
const common_1 = require("../../common/common");
const settings_1 = require("../../js/settings");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsTimecardContent',
    props: {
        timecardSettings: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        branchCanEditSettings: {
            type: Boolean,
            default: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isUpdating: {
            type: Boolean,
            default: false,
        },
        isDefaultSettingsPage: {
            type: Boolean,
            default: false,
        }
    },
    emits: ["emit-timecard-settings"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const { hasTimePerm, hasTrialPerm } = props.permissions;
        const savedSettings = (0, vue_3.ref)("");
        const ROUND_TYPES = {
            UP: "up",
            DOWN: "down",
        };
        const overtimeStartDays = [
            { value: dateInt_1.default.SUN, label: '日', class: 'th-holiday' },
            { value: dateInt_1.default.MON, label: '月', class: '' },
            { value: dateInt_1.default.TUE, label: '火', class: '' },
            { value: dateInt_1.default.WED, label: '水', class: '' },
            { value: dateInt_1.default.THUR, label: '木', class: '' },
            { value: dateInt_1.default.FRI, label: '金', class: '' },
            { value: dateInt_1.default.SAT, label: '土', class: 'th-saturday' },
        ];
        const localSettingsData = (0, vue_3.ref)({ ...props.timecardSettings });
        const localSettingsRoundData = (0, vue_3.ref)({
            from: 0,
            to: 0,
            restTo: 0,
            restFrom: 0,
        });
        const roundTypes = (0, vue_3.ref)({
            from: ROUND_TYPES.UP,
            to: ROUND_TYPES.UP,
            restFrom: ROUND_TYPES.UP,
            restTo: ROUND_TYPES.UP,
        });
        const canUse = (0, vue_3.computed)(() => {
            // need to check === true here otherwise typescript might return undefined.
            return (hasTimePerm || hasTrialPerm === true) && props.branchCanEditSettings;
        });
        const disabledPage = (0, vue_3.computed)(() => {
            return {
                'disabled-page': !canUse.value,
            };
        });
        function processTimeInput(value) {
            value = (0, common_1.fullWidthToAscii)(value);
            // Convert a single number to "hh:00" format (otherwise kitchenTimeToDuration will treat it as minutes)
            if (/^\d+$/.test(value)) {
                value = `${value}:00`;
            }
            return value;
        }
        const overtimeWarning = (0, vue_3.computed)({
            get: () => {
                let time = "";
                if (localSettingsData.value.overtimeWarning) {
                    time = (0, common_1.durationToKitchenTime)(localSettingsData.value.overtimeWarning, "minutes");
                }
                return time;
            },
            set: (value) => {
                value = processTimeInput(value);
                try {
                    const duration = (0, common_1.kitchenTimeToDuration)(value, "minutes");
                    // Ensure it doesn't exceed 23:59 (1439 minutes)
                    if (duration > 1439) {
                        localSettingsData.value.overtimeWarning = 1439;
                    }
                    else {
                        localSettingsData.value.overtimeWarning = duration;
                    }
                }
                catch (error) {
                    localSettingsData.value.overtimeWarning = 0;
                }
            }
        });
        const overtimeWarningMonthly = (0, vue_3.computed)({
            get: () => {
                let time = "";
                if (localSettingsData.value.overtimeWarningMonthly) {
                    time = (0, common_1.durationToKitchenTime)(localSettingsData.value.overtimeWarningMonthly, "minutes");
                }
                return time;
            },
            set: (value) => {
                value = processTimeInput(value);
                try {
                    localSettingsData.value.overtimeWarningMonthly = (0, common_1.kitchenTimeToDuration)(value, "minutes");
                }
                catch (error) {
                    localSettingsData.value.overtimeWarningMonthly = 0;
                }
            }
        });
        function getCurrentSettingsData() {
            return JSON.stringify({
                settings: localSettingsData.value,
                roundSettings: localSettingsRoundData.value,
                roundTypes: roundTypes.value,
            });
        }
        function handleOvertimeWarningChange(event) {
            const target = event.target;
            const newValue = target.value.trim();
            overtimeWarning.value = newValue;
        }
        function handleOvertimeWarningMonthlyChange(event) {
            const target = event.target;
            const newValue = target.value.trim();
            overtimeWarningMonthly.value = newValue;
        }
        function handleAutoRestLaborChange(event, index) {
            if (localSettingsData.value.timecardAutoRests[index]) {
                const target = event.target;
                localSettingsData.value.timecardAutoRests[index].labor = target.value;
            }
        }
        function handleAutoRestValueChange(event, index) {
            if (localSettingsData.value.timecardAutoRests[index]) {
                const target = event.target;
                localSettingsData.value.timecardAutoRests[index].value = target.value;
            }
        }
        function addAutoRest() {
            const autoRest = {
                labor: "",
                value: "",
            };
            localSettingsData.value.timecardAutoRests.push(autoRest);
        }
        function handleAutoRestDelete(index) {
            localSettingsData.value.timecardAutoRests.splice(index, 1);
        }
        function handleTimecardAutoDelete(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.timecardAutoDelete = newVal;
        }
        function handleTimecardCeilingFrom(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.timecardCeilingFrom = newVal;
        }
        function handleTimecardFloorTo(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.timecardFloorTo = newVal;
        }
        function handleRoundFrom(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsRoundData.value.from = newVal;
        }
        function handleRoundTo(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsRoundData.value.to = newVal;
        }
        function handleRoundRestFrom(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsRoundData.value.restFrom = newVal;
        }
        function handleRoundRestTo(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsRoundData.value.restTo = newVal;
        }
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": props.isUpdating,
            };
        });
        const emit = __emit;
        function absoluteRoundValues() {
            const from = props.timecardSettings.timecardRoundFrom;
            const to = props.timecardSettings.timecardRoundTo;
            const restFrom = props.timecardSettings.timecardRoundRestFrom;
            const restTo = props.timecardSettings.timecardRoundRestTo;
            roundTypes.value.from = from >= 0 ? ROUND_TYPES.UP : ROUND_TYPES.DOWN;
            roundTypes.value.to = to >= 0 ? ROUND_TYPES.UP : ROUND_TYPES.DOWN;
            roundTypes.value.restFrom = restFrom >= 0 ? ROUND_TYPES.UP : ROUND_TYPES.DOWN;
            roundTypes.value.restTo = restTo >= 0 ? ROUND_TYPES.UP : ROUND_TYPES.DOWN;
            localSettingsRoundData.value.from = Math.abs(from);
            localSettingsRoundData.value.to = Math.abs(to);
            localSettingsRoundData.value.restFrom = Math.abs(restFrom);
            localSettingsRoundData.value.restTo = Math.abs(restTo);
        }
        function getSettingsForSubmit() {
            if (!canUse.value) {
                return null;
            }
            localSettingsData.value.timecardAutoRests = localSettingsData.value.timecardAutoRests.length ? localSettingsData.value.timecardAutoRests : [];
            localSettingsData.value.timecardRoundFrom = localSettingsRoundData.value.from;
            localSettingsData.value.timecardRoundTo = localSettingsRoundData.value.to;
            localSettingsData.value.timecardRoundRestFrom = localSettingsRoundData.value.restFrom;
            localSettingsData.value.timecardRoundRestTo = localSettingsRoundData.value.restTo;
            const applyRounding = (value, roundType) => {
                return value > 0 && roundType === ROUND_TYPES.DOWN ? value * -1 : value;
            };
            localSettingsData.value.timecardRoundFrom = applyRounding(localSettingsRoundData.value.from, roundTypes.value.from);
            localSettingsData.value.timecardRoundTo = applyRounding(localSettingsRoundData.value.to, roundTypes.value.to);
            localSettingsData.value.timecardRoundRestFrom = applyRounding(localSettingsRoundData.value.restFrom, roundTypes.value.restFrom);
            localSettingsData.value.timecardRoundRestTo = applyRounding(localSettingsRoundData.value.restTo, roundTypes.value.restTo);
            return localSettingsData.value;
        }
        function handleTimecardSubmit() {
            const settings = getSettingsForSubmit();
            if (!settings) {
                return;
            }
            emit("emit-timecard-settings", localSettingsData);
        }
        function hasUnsavedChanges() {
            return getCurrentSettingsData() !== savedSettings.value;
        }
        function updateSaved() {
            savedSettings.value = getCurrentSettingsData();
        }
        __expose({
            hasUnsavedChanges,
            getSettingsForSubmit,
            updateSaved,
        });
        (0, vue_3.watch)(() => props.timecardSettings, (newSettings) => {
            localSettingsData.value = newSettings;
            absoluteRoundValues();
            updateSaved();
        }, { immediate: true }); // we want to fetch the initial data, and then re-fetch the data whenever relevant state changes.
        return (_ctx, _cache) => {
            return (__props.isLoading)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 1,
                    ref: "settingsContainer",
                    class: (0, vue_2.normalizeClass)(["main-settings-container", disabledPage.value])
                }, [
                    (!(0, vue_2.unref)(hasTimePerm) && !(0, vue_2.unref)(hasTrialPerm))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [...(_cache[17] || (_cache[17] = [
                                (0, vue_2.createElementVNode)("div", { class: "upgrade-message-card text-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "modal-title h4" }, "アップグレードが必要です"),
                                    (0, vue_2.createElementVNode)("br"),
                                    (0, vue_2.createElementVNode)("span", null, "この機能を使用するためには"),
                                    (0, vue_2.createElementVNode)("span", { class: "pro-label pro-plus m-2" }),
                                    (0, vue_2.createElementVNode)("span", null, "プランへアップグレードが必要です")
                                ], -1 /* CACHED */)
                            ]))]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("details", _hoisted_3, [
                        (0, vue_2.createCommentVNode)(" Timecard page settings "),
                        (0, vue_2.createElementVNode)("summary", _hoisted_4, [
                            _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }, null, -1 /* CACHED */)),
                            (0, vue_2.createVNode)(TimecardIcon_vue_1.default, { class: "page-title-text settings-accordion-icon" }),
                            (0, vue_2.createElementVNode)("span", _hoisted_5, [
                                _cache[18] || (_cache[18] = (0, vue_2.createTextVNode)("タイムカード ", -1 /* CACHED */)),
                                (__props.isDefaultSettingsPage)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_6, "（デフォルト設定）"))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            (0, vue_2.createCommentVNode)(" enableHideTimecard "),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                    _cache[21] || (_cache[21] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "打刻機能", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[20] || (_cache[20] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "タイムカード打刻機能を使用できなくする (打刻アプリを含む) ")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_11, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localSettingsData.value.enableHideTimecard) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.enableHideTimecard]
                                    ]),
                                    _cache[22] || (_cache[22] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" isHidingRestTimecard "),
                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                    _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "休憩ボタン", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "タイムカードの休憩開始・休憩終了ボタンを非表示にする")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_15, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((localSettingsData.value.isHidingRestTimecard) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isHidingRestTimecard]
                                    ]),
                                    _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" freePunch "),
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                    _cache[27] || (_cache[27] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "ボタンを常に表示", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[26] || (_cache[26] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "出勤・退勤ボタンを常に表示に、休憩開始・終了ボタンは非表示にする")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_19, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((localSettingsData.value.freePunch) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.freePunch]
                                    ]),
                                    _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" enableOfflineKiosk "),
                            (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                    _cache[30] || (_cache[30] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "オフライン同期", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[29] || (_cache[29] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "社員用ページでタイムカード打刻機能をオフラインでも利用可能にする ")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_23, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((localSettingsData.value.enableOfflineKiosk) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.enableOfflineKiosk]
                                    ]),
                                    _cache[31] || (_cache[31] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" timecardAutoDelete "),
                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                    _cache[33] || (_cache[33] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "打刻履歴", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[32] || (_cache[32] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "[X]分以内の打刻履歴は自動削除")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_28, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleTimecardAutoDelete,
                                            value: localSettingsData.value.timecardAutoDelete,
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_29),
                                        _cache[34] || (_cache[34] = (0, vue_2.createElementVNode)("span", null, "分", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" timecardCeilingFrom "),
                            (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                    _cache[36] || (_cache[36] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "出勤予定時刻", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_32, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[35] || (_cache[35] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "[X]分前までを丸め処理")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_34, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleTimecardCeilingFrom,
                                            value: localSettingsData.value.timecardCeilingFrom,
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_35),
                                        _cache[37] || (_cache[37] = (0, vue_2.createElementVNode)("span", null, "分", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" timecardFloorTo "),
                            (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                    _cache[39] || (_cache[39] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "退勤予定時刻", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_38, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[38] || (_cache[38] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "[X]分後までを丸め処理")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_39, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_40, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleTimecardFloorTo,
                                            value: localSettingsData.value.timecardFloorTo,
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_41),
                                        _cache[40] || (_cache[40] = (0, vue_2.createElementVNode)("span", null, "分", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" timecardRoundFrom "),
                            (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                _cache[46] || (_cache[46] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "出勤")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_44, [
                                        _cache[41] || (_cache[41] = (0, vue_2.createElementVNode)("span", null, "繰り", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleRoundFrom,
                                            value: localSettingsRoundData.value.from,
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_45)
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_46, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((roundTypes.value.from) = $event)),
                                            value: "up",
                                            type: "radio",
                                            name: "round-from-type"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roundTypes.value.from]
                                        ]),
                                        _cache[42] || (_cache[42] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[43] || (_cache[43] = (0, vue_2.createElementVNode)("span", null, "上げ", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_47, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((roundTypes.value.from) = $event)),
                                            value: "down",
                                            type: "radio",
                                            name: "round-from-type"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roundTypes.value.from]
                                        ]),
                                        _cache[44] || (_cache[44] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[45] || (_cache[45] = (0, vue_2.createElementVNode)("span", null, "下げ", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" timecardRoundTo "),
                            (0, vue_2.createElementVNode)("div", _hoisted_48, [
                                _cache[52] || (_cache[52] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "退勤")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_50, [
                                        _cache[47] || (_cache[47] = (0, vue_2.createElementVNode)("span", null, "繰り", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleRoundTo,
                                            value: localSettingsRoundData.value.to,
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_51)
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_52, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((roundTypes.value.to) = $event)),
                                            value: "up",
                                            type: "radio",
                                            name: "round-to-type"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roundTypes.value.to]
                                        ]),
                                        _cache[48] || (_cache[48] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[49] || (_cache[49] = (0, vue_2.createElementVNode)("span", null, "上げ", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_53, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((roundTypes.value.to) = $event)),
                                            value: "down",
                                            type: "radio",
                                            name: "round-to-type"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roundTypes.value.to]
                                        ]),
                                        _cache[50] || (_cache[50] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[51] || (_cache[51] = (0, vue_2.createElementVNode)("span", null, "下げ", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" timecardRoundRestFrom "),
                            (0, vue_2.createElementVNode)("div", _hoisted_54, [
                                _cache[58] || (_cache[58] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "休開")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_55, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_56, [
                                        _cache[53] || (_cache[53] = (0, vue_2.createElementVNode)("span", null, "繰り", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleRoundRestFrom,
                                            value: localSettingsRoundData.value.restFrom,
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_57)
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_58, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((roundTypes.value.restFrom) = $event)),
                                            value: "up",
                                            type: "radio",
                                            name: "round-rest-from-type"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roundTypes.value.restFrom]
                                        ]),
                                        _cache[54] || (_cache[54] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[55] || (_cache[55] = (0, vue_2.createElementVNode)("span", null, "上げ", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_59, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((roundTypes.value.restFrom) = $event)),
                                            value: "down",
                                            type: "radio",
                                            name: "round-rest-from-type"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roundTypes.value.restFrom]
                                        ]),
                                        _cache[56] || (_cache[56] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[57] || (_cache[57] = (0, vue_2.createElementVNode)("span", null, "下げ", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" timecardRoundRestTo "),
                            (0, vue_2.createElementVNode)("div", _hoisted_60, [
                                _cache[64] || (_cache[64] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "休終")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_61, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_62, [
                                        _cache[59] || (_cache[59] = (0, vue_2.createElementVNode)("span", null, "繰り", -1 /* CACHED */)),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: handleRoundRestTo,
                                            value: localSettingsRoundData.value.restTo,
                                            class: "form-input form-small",
                                            type: "text",
                                            placeholder: "1"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_63)
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_64, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((roundTypes.value.restTo) = $event)),
                                            value: "up",
                                            type: "radio",
                                            name: "round-rest-to-type"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roundTypes.value.restTo]
                                        ]),
                                        _cache[60] || (_cache[60] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[61] || (_cache[61] = (0, vue_2.createElementVNode)("span", null, "上げ", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_65, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((roundTypes.value.restTo) = $event)),
                                            value: "down",
                                            type: "radio",
                                            name: "round-rest-to-type"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roundTypes.value.restTo]
                                        ]),
                                        _cache[62] || (_cache[62] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                        _cache[63] || (_cache[63] = (0, vue_2.createElementVNode)("span", null, "下げ", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" timecardAutoRests "),
                            (0, vue_2.createElementVNode)("div", _hoisted_66, [
                                _cache[68] || (_cache[68] = (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "自動休憩")
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_67, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(localSettingsData.value.timecardAutoRests, (autoRest, index) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_68, [
                                            (0, vue_2.createElementVNode)("label", _hoisted_69, [
                                                (0, vue_2.createElementVNode)("input", {
                                                    value: autoRest.labor,
                                                    onChange: ($event) => (handleAutoRestLaborChange($event, index)),
                                                    class: "form-input oplus-input-time",
                                                    type: "time"
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_70),
                                                _cache[65] || (_cache[65] = (0, vue_2.createTextVNode)(" 時間につき ", -1 /* CACHED */))
                                            ]),
                                            (0, vue_2.createElementVNode)("label", _hoisted_71, [
                                                (0, vue_2.createElementVNode)("input", {
                                                    value: autoRest.value,
                                                    onChange: ($event) => (handleAutoRestValueChange($event, index)),
                                                    class: "form-input oplus-input-time",
                                                    type: "time"
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_72),
                                                _cache[66] || (_cache[66] = (0, vue_2.createTextVNode)(" の休憩 ", -1 /* CACHED */))
                                            ]),
                                            (0, vue_2.createElementVNode)("i", {
                                                class: "zmdi zmdi-close zmdi-hc-lg text-gray c-hand",
                                                onClick: ($event) => (handleAutoRestDelete(index))
                                            }, null, 8 /* PROPS */, _hoisted_73)
                                        ]));
                                    }), 256 /* UNKEYED_FRAGMENT */)),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "oplus-add-icon auto-add-button",
                                        onClick: addAutoRest
                                    }, [...(_cache[67] || (_cache[67] = [
                                            (0, vue_2.createElementVNode)("i", { class: "icon icon-plus" }, null, -1 /* CACHED */)
                                        ]))])
                                ])
                            ])
                        ])
                    ]),
                    (0, vue_2.createCommentVNode)(" QR code settings "),
                    (0, vue_2.createElementVNode)("details", _hoisted_74, [
                        (0, vue_2.createElementVNode)("summary", _hoisted_75, [
                            _cache[69] || (_cache[69] = (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }, null, -1 /* CACHED */)),
                            (0, vue_2.createVNode)(QRCodeIcon_vue_1.default, { class: "page-title-text settings-accordion-icon" }),
                            _cache[70] || (_cache[70] = (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "QRコード", -1 /* CACHED */))
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_76, [
                            (0, vue_2.createCommentVNode)(" branchBasedPunch "),
                            (0, vue_2.createElementVNode)("div", _hoisted_77, [
                                (0, vue_2.createElementVNode)("div", _hoisted_78, [
                                    _cache[72] || (_cache[72] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "拠点打刻", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_79, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[71] || (_cache[71] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "拠点打刻用QRコードを使う（タイムカードを非表示にする）")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_80, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((localSettingsData.value.branchBasedPunch) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.branchBasedPunch]
                                    ]),
                                    _cache[73] || (_cache[73] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ])
                        ])
                    ]),
                    (0, vue_2.createCommentVNode)(" Time page settings "),
                    (0, vue_2.createElementVNode)("details", _hoisted_81, [
                        (0, vue_2.createElementVNode)("summary", _hoisted_82, [
                            _cache[74] || (_cache[74] = (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }, null, -1 /* CACHED */)),
                            (0, vue_2.createVNode)(TimeIcon_vue_1.default, { class: "page-title-text settings-accordion-icon" }),
                            _cache[75] || (_cache[75] = (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "勤怠管理", -1 /* CACHED */))
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_83, [
                            (0, vue_2.createCommentVNode)(" overtimeAlertStartDay "),
                            (0, vue_2.createElementVNode)("div", _hoisted_84, [
                                (0, vue_2.createElementVNode)("div", _hoisted_85, [
                                    _cache[77] || (_cache[77] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週の起算日", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_86, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[76] || (_cache[76] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "週40時間労働の割増計算をする際の、起算日となる曜日を選択してください。")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_87, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_88, [
                                        (0, vue_2.createElementVNode)("label", _hoisted_89, [
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((localSettingsData.value.overtimeAlertStartDayEnabled) = $event)),
                                                type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.overtimeAlertStartDayEnabled]
                                            ]),
                                            _cache[78] || (_cache[78] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                        ])
                                    ]),
                                    (localSettingsData.value.overtimeAlertStartDayEnabled)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_90, [
                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(overtimeStartDays, (day) => {
                                                return (0, vue_2.createElementVNode)("label", {
                                                    key: day.value,
                                                    class: "oplus-form-radio"
                                                }, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((localSettingsData.value.overtimeAlertStartDay) = $event)),
                                                        value: day.value,
                                                        type: "radio",
                                                        name: "overtime-alert-start-day"
                                                    }, null, 8 /* PROPS */, _hoisted_91), [
                                                        [vue_2.vModelRadio, localSettingsData.value.overtimeAlertStartDay]
                                                    ]),
                                                    _cache[79] || (_cache[79] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */)),
                                                    (0, vue_2.createElementVNode)("span", {
                                                        class: (0, vue_2.normalizeClass)(day.class)
                                                    }, (0, vue_2.toDisplayString)(day.label), 3 /* TEXT, CLASS */)
                                                ]);
                                            }), 64 /* STABLE_FRAGMENT */))
                                        ]))
                                        : (0, vue_2.createCommentVNode)("v-if", true)
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" isHidingTimeCardEdit "),
                            (0, vue_2.createElementVNode)("div", _hoisted_92, [
                                (0, vue_2.createElementVNode)("div", _hoisted_93, [
                                    _cache[81] || (_cache[81] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "タイムカード編集", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_94, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[80] || (_cache[80] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "勤怠管理ページのタイムカード作成と編集をできなくする")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_95, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((localSettingsData.value.isHidingTimeCardEdit) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isHidingTimeCardEdit]
                                    ]),
                                    _cache[82] || (_cache[82] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" punchLocation "),
                            (0, vue_2.createElementVNode)("div", _hoisted_96, [
                                (0, vue_2.createElementVNode)("div", _hoisted_97, [
                                    _cache[84] || (_cache[84] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "位置情報が必要", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_98, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[83] || (_cache[83] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "GPS打刻機能で、打刻時に位置情報を取得して打刻を行う")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_99, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((localSettingsData.value.punchLocation) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.punchLocation]
                                    ]),
                                    _cache[85] || (_cache[85] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                                ])
                            ])
                        ])
                    ]),
                    (0, vue_2.createCommentVNode)(" Overtime settings "),
                    (0, vue_2.createElementVNode)("details", _hoisted_100, [
                        _cache[90] || (_cache[90] = (0, vue_2.createElementVNode)("summary", { class: "settings-title-wrapper accordion-header c-hand" }, [
                            (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right" }),
                            (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "労務設定")
                        ], -1 /* CACHED */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_101, [
                            (0, vue_2.createCommentVNode)(" overtimeWarning "),
                            (0, vue_2.createElementVNode)("div", _hoisted_102, [
                                (0, vue_2.createElementVNode)("div", _hoisted_103, [
                                    _cache[87] || (_cache[87] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "日別労務アラート", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_104, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[86] || (_cache[86] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "勤務実績が設定時間を超えた時に通知")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_105, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleOvertimeWarningChange,
                                        value: overtimeWarning.value,
                                        class: "form-input oplus-input-time",
                                        type: "text",
                                        placeholder: "hh:mm"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_106)
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" overtimeWarningMonthly "),
                            (0, vue_2.createElementVNode)("div", _hoisted_107, [
                                (0, vue_2.createElementVNode)("div", _hoisted_108, [
                                    _cache[89] || (_cache[89] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月別労務アラート", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_109, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _cache[88] || (_cache[88] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper tooltip-wrapper-top" }, [
                                            (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "月別で設定した勤務時間を超えた時に通知")
                                        ], -1 /* CACHED */))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_110, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleOvertimeWarningMonthlyChange,
                                        value: overtimeWarningMonthly.value,
                                        class: "form-input oplus-input-time",
                                        type: "text",
                                        placeholder: "hh:mm"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_111)
                                ])
                            ])
                        ])
                    ]),
                    (canUse.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_112, [
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn oplus-save-btn", loadingClass.value]),
                                onClick: handleTimecardSubmit
                            }, "保存", 2 /* CLASS */)
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ], 2 /* CLASS */));
        };
    }
});
